/**************************************************
 * Nombre:       Formacion_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/Temporales/fondo_portada.png'
import fondo_cell from '../../../Recursos/fondo_portada_celular.png'
import {NEGRITA} from "../../../Constantes";
import Boton from "./Subcomponentes/Boton";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Registro from "../../Dialogos/Dialogo_Registro";
import {iniciarChatWass} from "../../../Utilidades/iniciarChatWass";

const Formacion_Portada = ({item}) => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Registro, titulo: 'Formulario de Registro'})

    const abrirRegistro = () => {

        abrir(item);
    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: sCell ? `linear-gradient(0deg, #303376 30.51%, rgba(61, 66, 128, 0.00) 99.56%), url(${item.imgCell ? item.imgCell : fondo_cell})`
                    : `linear-gradient(-270deg, #303376 30.51%, rgba(61, 66, 128, 0.00) 99.56%), url(${item.img ? item.img : fondo})`,
                backgroundSize: 'cover',
                backgroundPosition: 'top center',
            }}

        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 8}}
                        sx={{color: "#fff"}}
                    >

                        {!sCell &&
                            <Grid container size={{xs: 12, sm: 8, md: 8}} sx={{justifyContent: 'flex-start', mt: 14}}>
                                <Typography
                                    sx={{fontSize: 18, fontWeight: 400}}
                                >
                                    {item.avalado}
                                </Typography>
                            </Grid>
                        }


                        <Grid container size={{xs: 12, sm: 8, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: sCell ? 28 : 2}}>
                            <Typography sx={{
                                fontFamily: NEGRITA,
                                fontSize: sCell ? 40 : 64,
                                lineHeight: 1,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                {item.nombre}
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={sCell ? 'center' : 'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={sCell ? 2 : 4}
                            sx={{mt: 4}}
                        >

                            <Boton click={abrirRegistro}
                                   texto={'Obtener mi Certificado'}/>

                            <Button
                                onClick={() => iniciarChatWass({mensaje: `Hola Centro de conciliacion, quiero mas informacion sobre: ${item.nombre}`})}
                                variant={'outlined'} color={'info'}>Mas información</Button>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 8, md: 8}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 6, mb: sCell ? 0 : 14}}>
                            <Typography
                                sx={{fontSize: 16, fontWeight: 300, textAlign: sCell ? 'center' : 'left'}}
                            >
                                "Formando operadores de justicia privada con perspectiva de género y enfoque diferencial"
                            </Typography>
                        </Grid>

                        {sCell &&
                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: 2, mb: 14}}>
                                <Typography
                                    sx={{fontSize: 14, fontWeight: 400, textAlign: 'center', color: '#fff'}}
                                >
                                    {item.avalado}
                                </Typography>
                            </Grid>
                        }


                    </Grid>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Formacion_Portada